
import React from 'react';
import PropTypes from 'prop-types';
import MultipleChoiceQuestion from '../questions/MultipleChoiceQuestion';
import MultipleAnswerQuestion from '../questions/MultipleAnswerQuestion';
import NumberQuestion from "../questions/NumberQuestion";
import WeightQuestion from "../questions/WeightQuestion";
import HeightQuestion from "../questions/HeightQuestion";
import TextQuestion from '../questions/TextQuestion';
import questionTypes from '../questions/questionTypes.json';
import {
  uniqBy
} from 'ramda';
import MultipleAnswerQuestionCombo from '../questions/MultipleAnswerComboQuestion/MultipleAnswerQuestionCombo';
import { RangeQuestion } from '../questions/RangeQuestion';
import { YesNoQuestion } from '../questions/YesNoQuestion/YesNoQuestion';

QuestionnaireReview.propTypes = {
  questions: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
  units: PropTypes.array
};

function getUniqueQuestions(questions) {
  return uniqBy(question => question.questionId, questions);
}

function QuestionnaireReview({
  questions,
  answers,
  units
}) {
  return (
    <div className='row'>
      {getUniqueQuestions(questions).map((question, index) => {
        const questionAnswers = answers.filter(answer => answer.questionId === question.questionId);
        switch (question.type) {
        case questionTypes.multipleChoice:
          return <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'><MultipleChoiceQuestion
            key={index}
            questionId={question.questionId}
            text={question.text}
            options={question.options}
            readOnly
            answers={questionAnswers} /></div>;
        case questionTypes.multipleAnswer:
          return <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'><MultipleAnswerQuestion
            key={index}
            questionId={question.questionId}
            text={question.text}
            options={question.options}
            readOnly
            answers={questionAnswers} /></div>;
        case questionTypes.multipleAnswerCombo:
          return <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'><MultipleAnswerQuestionCombo
            key={index}
            questionId={question.questionId}
            text={question.text}
            options={question.options}
            readOnly
            answers={questionAnswers} /></div>;
        case questionTypes.number:
          return <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'><NumberQuestion
            key={index}
            questionId={question.questionId}
            text={question.text}
            readOnly
            options={question.options}
            answers={questionAnswers} /></div>;
        case questionTypes.weight:
          return <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'><WeightQuestion
            key={index}
            questionId={question.questionId}
            text={question.text}
            readOnly
            options={question.options}
            answers={questionAnswers}
            units={units} /></div>;
        case questionTypes.height:
          return <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'><HeightQuestion
            key={index}
            questionId={question.questionId}
            text={question.text}
            readOnly
            options={question.options}
            answers={questionAnswers}
            units={units} /></div>;
        case questionTypes.text:
          return <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'><TextQuestion
            key={index} p
            questionId={question.questionId}
            text={question.text}
            readOnly
            options={question.options}
            answers={questionAnswers} /></div>;
        case questionTypes.range:
          return <RangeQuestion
            key={question.questionId}
            questionId={question.questionId}
            text={question.text}
            options={question.options}
            answers={questionAnswers}
            validationState={question.validationState}
            readOnly
            help={question.help}
          />;
        case questionTypes.yesNo:
          return <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'><YesNoQuestion
            key={index}
            questionId={question.questionId}
            text={question.text}
            options={question.options}
            readOnly
            answers={questionAnswers} /></div>;
        default:
          return <span key={index}>Invalid question Type</span>;
        }
      })}
    </div>
  )
}

export default QuestionnaireReview;



// WEBPACK FOOTER //
// ./src/components/submitQuestionnaire/QuestionnaireReview.js